module.exports = __webpack_public_path__ + "static/media/auto-1.10341732.png";